<template>
    <form class="login-form" @submit.prevent="submitForm">
        <h1 class="h1 login-form__title">Вход</h1>

        <div class="cabinet-form-group">
            <label class="cabinet-form-group__label" for="email"
                >Электронная почта</label
            >
            <input
                id="email"
                v-model="user.Email"
                type="email"
                class="cabinet-form-group__input"
            />
        </div>

        <div class="cabinet-form-group">
            <label class="cabinet-form-group__label" for="password"
                >Пароль</label
            >
            <input
                id="password"
                v-model="user.Password"
                type="password"
                class="cabinet-form-group__input"
            />
        </div>

        <button
            type="submit"
            class="cabinet-btn cabinet-btn--big cabinet-btn--w100"
        >
            Войти
        </button>

        <a
            href="javascript:void(0)"
            class="app-link app-link--blue login-form__forget-link"
            >Забыли пароль?</a
        >

        <div class="login-form__alredy-registered text-center">
            Хотите стать партнером?
            <router-link to="/" class="app-link app-link--blue"
                >Зарегистрируйтесь</router-link
            >
        </div>

        <a
            href="http://www.goldnet.market"
            target="_blank"
            class="login-form__home-link"
            >Перейти на www.goldnet.market</a
        >
    </form>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    name: 'SignIn',
    data() {
        return {
            user: {
                Email: '',
                Password: ''
            }
        }
    },
    methods: {
        async submitForm() {
            const user = await this.$axios
                .post('/auth/login', this.user)
                .then(res => res.data)
                .catch(() => {
                    alert('Неверный Email или пароль')
                })
            if (user) {
                this.setUser(user)
            }
        },
        ...mapActions('user', ['setUser'])
    }
}
</script>
